function isNullish(value) {
  return value === null || value === undefined || value === "";
}

if (!customElements.get("gift-dispatcher")) {
  customElements.define(
    "gift-dispatcher",
    class GiftDispatcher extends HTMLElement {
      constructor() {
        super();
        this.gifts = this.querySelectorAll('input[type="hidden"]');
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer") ||
          document.querySelector("deployer-cart-drawer");
        this.cartURLs = {
          add: `/cart/add.js`,
          change: `/cart/change.js`,
          update: `/cart/update.js`,
          cart: `/cart.json`,
        };
        this.limitedVariantIds = [];
        this.maxQuantity = 1;
      }

      connectedCallback() {
        if (window.deployerAdapter.enable_gift_dispatcher === true) {
          this.initializeLimitedVariantIds();
          this.listenEvents();
        }
      }

      disconnectedCallback() {
        this.removeEvents();
      }

      initializeLimitedVariantIds() {
        this.gifts.forEach((gift) => {
          if (!isNullish(gift.dataset.variantId)) {
            this.limitedVariantIds.push(parseInt(gift.dataset.variantId));
          }
        });
      }

      listenEvents() {
        document.addEventListener("deployer-cart-drawer:refresh", () => {
          this.getCart().then((cart) => {
            this.validateConditions(cart);
          });
        });
        document.addEventListener("cart-product:add", () => {
          this.getCart().then((cart) => {
            this.validateConditions(cart);
          });
        });
        document.addEventListener("cart-product:change", () => {
          this.getCart().then((cart) => {
            this.validateConditions(cart);
          });
        });

        const cartRemoveElements = document.querySelectorAll(".cart__remove");
        cartRemoveElements.forEach((element) => {
          element.addEventListener("click", (event) => {
            event.preventDefault();
            setTimeout(() => {
              this.getCart().then((cart) => {
                this.validateConditions(cart);
              });
            }, 500);
          });
        });
      }

      removeEvents() {}

      async getCart() {
        return fetch(this.cartURLs.cart, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        })
          .then((response) => response.json())
          .then((response) => {
            return response;
          })
          .catch((error) => {
            console.error("Error:", error);
          });
      }

      validateConditions(cart) {
        for (const gift of this.gifts) {
          if (
            isNullish(gift.dataset.variantId) ||
            isNullish(gift.dataset.tierType)
          )
            return;

          const variantId = parseInt(gift.dataset.variantId);
          const tierType = gift.dataset.tierType;
          const isSufficient = this.isTierSatisfied(cart, tierType, gift);

          const restrictedItem = cart.items.find(
            (item) => item.id.toString() == variantId
          );
          if (restrictedItem && restrictedItem.quantity > 1) {
            this.limitProductQuantity(cart, restrictedItem.id);
          }

          if (isSufficient === false) {
            this.removeGift(cart, variantId);
            continue;
          }

          if (this.isAlreadyOnCart(cart, variantId)) {
            continue;
          }

          this.addToCartGift(variantId);
        }
      }

      async limitProductQuantity(cart, productId) {
        let lineIndex = cart.items.findIndex(
          (item) => item.variant_id == productId
        );
        if (lineIndex === -1) return;
        let bodyConfig = JSON.stringify({
          line: lineIndex + 1,
          quantity: 1,
        });

        return fetch(this.cartURLs.change, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: bodyConfig,
        })
          .then((response) => response.json())
          .then(() => {
            console.log(`Quantité ajustée pour le produit ${productId} à 1.`);
            this.updateCart();
          })
          .catch((error) =>
            console.error(
              "Erreur lors de la mise à jour de la quantité :",
              error
            )
          );
      }

      isTierSatisfied(cart, type, gift) {
        switch (type) {
          case "cart_items_count":
            return GiftDispatcherOnCartItemsCount.validateConditions(
              cart,
              gift
            );
          case "cart_amount":
            return GiftDispatcherOnCartAmount.validateConditions(cart, gift);
          case "product_on_cart":
            return GiftDispatcherOnProductInCart.validateConditions(cart, gift);
          default:
            return false;
        }
      }

      isAlreadyOnCart(cart, variantId) {
        return cart.items.some((item) => item.variant_id == variantId);
      }

      updateCart() {
        document.dispatchEvent(new CustomEvent("deployer-cart-drawer:refresh"));
      }

      async addToCartGift(variantId) {
        let bodyConfig = JSON.stringify({
          items: [
            {
              id: variantId,
              quantity: 1,
            },
          ],
        });

        if (this.cart) {
          bodyConfig = JSON.stringify({
            items: [
              {
                id: variantId,
                quantity: 1,
              },
            ],
            sections: this.cart
              .getSectionsToRender()
              .map((section) => section.id),
            sections_url: window.location.pathname,
          });
        }

        return fetch(this.cartURLs.add, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: bodyConfig,
        })
          .then((response) => response.json())
          .then(() => {
            this.updateCart();
          })
          .catch((error) => {
            console.error("Error adding gift to cart:", error);
          });
      }

      async removeGift(cart, variantId) {
        let lineIndex = cart.items.findIndex(
          (item) => item.variant_id == variantId
        );
        if (lineIndex === -1) return;
        let bodyConfig = JSON.stringify({
          line: lineIndex + 1,
          quantity: 0,
        });

        return fetch(this.cartURLs.change, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: bodyConfig,
        })
          .then((response) => response.json())
          .then(() => {
            this.updateCart();
          })
          .catch((error) => {
            console.error("Error removing gift to cart:", error);
          });
      }
    }
  );
}

var GiftDispatcherOnCartAmount = class {
  static isCartAmountSufficient(cart, cartAmount) {
    const cartTotal = cart.items_subtotal_price;
    return cartTotal >= cartAmount;
  }

  static validateConditions(cart, gift) {
    if (isNullish(gift.dataset.cartAmount)) return false;

    const cartAmount = parseFloat(gift.dataset.cartAmount);
    const isSufficient = this.isCartAmountSufficient(cart, cartAmount);
    const isAvailable = gift.dataset.variantAvailable === "true";

    if (!isSufficient) {
      // console.warn(`Tier is not sufficient for adding gift ${variantId}`);
      return false;
    }

    if (!isAvailable) {
      // console.warn(`Gift ${variantId} is not available`);
      return false;
    }

    return true;
  }
};

var GiftDispatcherOnCartItemsCount = class {
  static isCartItemsCountSufficient(cart, cartItemsCount) {
    const cartItems = cart.item_count;
    return cartItems >= cartItemsCount;
  }

  static validateConditions(cart, gift) {
    if (isNullish(gift.dataset.cartItemsCount)) return false;

    const cartItemsCount = parseInt(gift.dataset.cartItemsCount);
    const isSufficient = this.isCartItemsCountSufficient(cart, cartItemsCount);
    const isAvailable = gift.dataset.variantAvailable === "true";

    if (!isSufficient) {
      // console.warn(`Tier is not sufficient for adding gift ${variantId}`);
      return false;
    }

    if (!isAvailable) {
      // console.warn(`Gift ${variantId} is not available`);
      return false;
    }

    return true;
  }
};

var GiftDispatcherOnProductInCart = class {
  static isProductDispatcherOnCart(cart, productId) {
    return cart.items.some((item) => item.product_id == productId);
  }

  static validateConditions(cart, gift) {
    if (isNullish(gift.dataset.variantId)) {
      // console.warn("Variant ID is not defined");
      return false;
    }

    const isAvailable = gift.dataset.variantAvailable === "true";
    const productDispatcherId = parseInt(gift.dataset.productDispatcherId);
    const isProductDispatcherOnCart = this.isProductDispatcherOnCart(
      cart,
      productDispatcherId
    );

    if (!isProductDispatcherOnCart) {
      // console.warn(`Dispatcher is not on cart`);
      return false;
    }

    if (!isAvailable) {
      // console.warn(`Gift ${variantId} is not available`);
      return false;
    }

    return true;
  }
};
